import { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { IOpoAgreement } from '@nkr/models/opo-admin-settings';
import { IOpoAdminSaveResult } from '@nkr/store/opo/hooks/use-opo-admin-settings';
import DocumentRow from '../document-row';

interface IProps {
    agreements: IOpoAgreement[],
    onUpload: (agreement: IOpoAgreement, file: File) => Promise<IOpoAdminSaveResult>,
    onDownload: (agreement: IOpoAgreement) => void
}

const Agreements = ({ agreements, onUpload, onDownload }: IProps) => {
    const [error, setError] = useState('');

    return (
        <div className='settings-card'>
            <div className='settings-card-header'>
                <h4>Agreements &amp; Contracts</h4>
            </div>

            <div className='settings-card-body'>
                {error && (
                    <Alert bsStyle='danger' onDismiss={() => setError('')}>{error}</Alert>
                )}

                {agreements.map(agreement =>
                    <div key={agreement.documentTypeId} className='settings-row'>
                        <label className='control-label wrap'>{agreement.name}</label>
                        <DocumentRow
                            document={agreement}
                            canUpload={true}
                            onUpload={(x, file) => { setError(''); return onUpload(x, file); }}
                            onDownload={onDownload}
                            onError={setError}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default Agreements;
